import { ServiceNotification } from '@shared-ui/components/service/notification'
import { useSheetPortals } from '@web/hooks/ui/use-sheet-portals'
import { createPortal } from 'react-dom'
import styles from './styles.module.css'

// Тосты должны быть выше шитов (overlay 1000 / content 1001) и их backdrop.
// Порталим в тот же контейнер, что и шиты, но с более высоким z-index.
export function NotificationHost() {
  const { portalContainer, useBodyPortal } = useSheetPortals()

  if (typeof document === 'undefined') return null

  const notification = <ServiceNotification />
  const hostClassName = useBodyPortal ? styles.hostWideDesktop : styles.host
  const content = useBodyPortal ? <div className={styles.column}>{notification}</div> : notification

  return createPortal(<div className={hostClassName}>{content}</div>, portalContainer ?? document.body)
}
